module.exports = __webpack_public_path__ + "static/media/tracking2.a2f2539d.png";